import { z } from "zod";

export const diseaseSchema = z.object({
  long_name: z.string().trim().min(1, "Long name is required").max(500),
  short_name: z.string().trim().min(1, "Short name is required").max(500),
  other_names: z.string().trim().max(500).optional(),
  display_name: z.string().trim().max(500).optional(),
  icd10_code: z.string().trim().max(15).optional(),
  widely_prevalent: z.boolean().default(false),
  family_linked: z.boolean().default(false),
  is_featured: z.boolean().default(false),
});

export type DiseaseFormValues = z.infer<typeof diseaseSchema>;

export const DISEASE_DEFAULT_VALUES: DiseaseFormValues = {
  long_name: "",
  short_name: "",
  other_names: "",
  display_name: "",
  icd10_code: "",
  widely_prevalent: false,
  family_linked: false,
  is_featured: false,
};

export const diseaseToFormValues = (
  disease?: Partial<DiseaseFormValues>
): DiseaseFormValues => ({
  long_name: disease?.long_name ?? "",
  short_name: disease?.short_name ?? "",
  other_names: disease?.other_names ?? "",
  display_name: disease?.display_name ?? "",
  icd10_code: disease?.icd10_code ?? "",
  widely_prevalent: disease?.widely_prevalent ?? false,
  family_linked: disease?.family_linked ?? false,
  is_featured: disease?.is_featured ?? false,
});
